import React from 'react';
import { Modal } from '../../ui/Modal';
import { useConversationPalette } from '../../conversation/ConversationTheme';

interface InactivityCountdownModalProps {
  open?: boolean;
  countdown: number;
  totalSeconds: number;
  onCancel: () => void;
}

export const InactivityCountdownModal: React.FC<InactivityCountdownModalProps> = ({ open = true, countdown, totalSeconds, onCancel }) => {
  const palette = useConversationPalette();
  return (
    <Modal open={open} onClose={onCancel}>
      <div className="text-center space-y-6">
        {/* Warning Icon + Countdown Circle */}
        <div className="mx-auto relative w-24 h-24 flex items-center justify-center">
          <svg className="w-24 h-24 absolute transform -rotate-90">
            <circle
              cx="48"
              cy="48"
              r="44"
              stroke="currentColor"
              strokeWidth="4"
              fill="none"
              className="text-ink"
            />
            <circle
              cx="48"
              cy="48"
              r="44"
              stroke="currentColor"
              strokeWidth="4"
              fill="none"
              className="text-warning"
              strokeDasharray={276.46}
              strokeDashoffset={276.46 * (1 - countdown / totalSeconds)}
              strokeLinecap="round"
              style={{ transition: 'stroke-dashoffset 1s linear' }}
            />
          </svg>
          <span className="text-4xl font-bold text-warning z-10">{countdown}</span>
        </div>

        {/* Content */}
        <div>
          <h3 className="text-xl font-bold text-foreground mb-2">Are you still there?</h3>
          <p className="text-muted-foreground">
            You will be disconnected for inactivity in <span className="text-warning font-bold">{countdown}</span> seconds.
          </p>
        </div>

        {/* Cancel Button */}
        <button
          onClick={onCancel}
          className={`w-full py-3 px-6 font-semibold rounded-xl transition-colors ${palette ? 'button-accent' : 'bg-success hover:bg-success text-success-foreground'}`}
        >
          I'm still here
        </button>
      </div>
    </Modal>
  );
};
